import intermind from '../../index';
import { VoiceAssistantProvider, VoiceAssistantState } from './types/assistant.types';

export class AssistantResource {
  async state(conferenceId: string): Promise<VoiceAssistantState> {
    const { data } = await intermind.httpClient.get<VoiceAssistantState>(
      `/voice-assistant/state?conferenceId=${conferenceId}`
    );
    return data;
  }

  async enable(conferenceId: string, provider: VoiceAssistantProvider): Promise<void> {
    await intermind.httpClient.post('/voice-assistant/enable', { conferenceId, provider });
  }

  async disable(conferenceId: string): Promise<void> {
    await intermind.httpClient.post('/voice-assistant/disable', { conferenceId });
  }

  async interrupt(conferenceId: string): Promise<void> {
    await intermind.httpClient.post('/voice-assistant/interrupt', { conferenceId });
  }

  async changeProvider(conferenceId: string, provider: VoiceAssistantProvider): Promise<void> {
    await intermind.httpClient.post('/voice-assistant/provider/change', { conferenceId, provider });
  }
}
